(ns app.survey.form.event
  (:require
   [ajax.core :as ajax]
   [app.survey.event :as app-event]
   [app.survey.form.sub :as sub]
   [clojure.string :as string]
   [common.util :as cu]
   [frontend.exports.excel :as excel]
   [frontend.view.nev.surveys.form.sub :as form-sub]
   [frontend.zap-time :as zap-time]
   [potpuri.core :as potpuri]
   [re-frame.core :as rf]
   [ui.view.survey.event :as survey-view-event]
   [ui.view.survey.sub :as survey-view-sub]))

(rf/reg-event-fx
 ::on-save-wip-ok
 (fn [{db :db} [_]]
   {:fx [[:dispatch [::app-event/load-process (get-in db [::sub/survey-process :db/id])]]]}))

(rf/reg-event-fx
 ::on-save-wip-failed
 (fn [{db :db} [_]]
   (js/console.log "Unimplmeented on-save-wip-failed")
   {}))

(rf/reg-event-fx
 ::save-wip
 (fn [{db :db} [_]]
   (let [edit-answers (get-in db [::form-sub/edit-answer-lookup] {})
         survey-answers (get-in db [::sub/answers])
         unsaved-changes (->> edit-answers
                              (remove (fn [[id v]]
                                        (= v (get survey-answers id))))
                              (seq))
         edit-no-answers (get-in db [::form-sub/edit-no-answer-lookup] {})
         survey-no-answer-descriptions (get-in db [::sub/survey-no-answer-descriptions])
         unsaved-no-changes (->> edit-no-answers
                                 (remove (fn [[id v]]
                                           (= v (get survey-no-answer-descriptions id))))
                                 (seq))]
     (when (or unsaved-changes unsaved-no-changes)
       {:http-xhrio {:method          :post
                     :uri             "/surveys/api/save-process-wip-guest"
                     :params          {:process-id (get-in db [::sub/survey-process :db/id])
                                       :updates    (into {} unsaved-changes)
                                       :no-answers (into {} unsaved-no-changes)}
                     :timeout         30000
                     :format          (ajax/transit-request-format)
                     :response-format (ajax/transit-response-format)
                     :on-success      [::on-save-wip-ok]
                     :on-failure      [::on-save-wip-failed]}}))))

(rf/reg-event-fx
 ::on-submit-wip-ok
 (fn [{db :db} [_]]
   {:fx [[:dispatch [::app-event/load-process (get-in db [::sub/survey-process :db/id])]]]}))

(rf/reg-event-fx
 ::on-submit-wip-failed
 (fn [{db :db} [_]]
   (js/console.log "Unimplmeented on-submit-wip-failed")
   {}))

(rf/reg-event-fx
 ::submit-wip
 (fn [{db :db} [_]]
   {:http-xhrio {:method          :post
                 :uri             "/surveys/api/submit-process-wip-quest"
                 :params          {:process-id (get-in db [::sub/survey-process :db/id])}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-submit-wip-ok]
                 :on-failure      [::on-submit-wip-failed]}}))


(rf/reg-event-fx
 ::on-logout-ok
 (fn [{db :db} [_]]
   (js/console.log "Logout ok reroute to root")
   (set! js/location.href "/")
   {}))

(rf/reg-event-fx
 ::on-logout-failed
 (fn [{db :db} [_]]
   (js/console.log "Unimplmeented on-logout-failed")
   {}))

(rf/reg-event-fx
 ::lang-change
 (fn [{db :db} [_ lang]]
   {:db (-> db
            (assoc-in [::sub/language] lang))}))

(def ^:private fonts
  {:Palatino   {:bold "https://static.zapflow.com/fonts/palatino-types/PalatinoLTPro-Bold.ttf"}
   :NewsGothic {:normal      "https://static.zapflow.com/fonts/ngo_____.ttf"
                :bold        "https://static.zapflow.com/fonts/ngob____.ttf"
                :italics     "https://static.zapflow.com/fonts/ngoi____.ttf"
                :bolditalics "https://static.zapflow.com/fonts/ngobi___.ttf"}
   :Roboto     {:normal      "https://static.zapflow.com/fonts/Roboto-Regular.ttf"
                :bold        "https://static.zapflow.com/fonts/Roboto-Medium.ttf"
                :italics     "https://static.zapflow.com/fonts/Roboto-Italic.ttf"
                :bolditalics "https://static.zapflow.com/fonts/Roboto-MediumItalic.ttf"}
   :Arial      {:normal      "https://static.zapflow.com/fonts/Arial.ttf"
                :bold        "https://static.zapflow.com/fonts/ArialBold.ttf"
                :italics     "https://static.zapflow.com/fonts/ArialItalic.ttf"
                :bolditalics "https://static.zapflow.com/fonts/ArialBoldItalic.ttf"}
   :Raleway    {:normal      "https://static.zapflow.com/fonts/Raleway-Regular.ttf"
                :bold        "https://static.zapflow.com/fonts/Raleway-Bold.ttf"
                :italics     "https://static.zapflow.com/fonts/Raleway-Italic.ttf"
                :bolditalics "https://static.zapflow.com/fonts/Raleway-BoldItalic.ttf"}
   :OpenSans   {:normal      "https://static.zapflow.com/fonts/OpenSans-Regular.ttf"
                :bold        "https://static.zapflow.com/fonts/OpenSans-Bold.ttf"
                :italics     "https://static.zapflow.com/fonts/OpenSans-Italic.ttf"
                :bolditalics "https://static.zapflow.com/fonts/OpenSans-BoldItalic.ttf"}})

(defn html->pdfmake-elements
  [html-str]
  (js/htmlToPdfmake (clj->js html-str)))

(defn html->pdfmake-content
  [html-str styles]
  (let [paragraphs (->> (string/split html-str "<p>")
                        (mapcat (fn [p]
                                  (string/split p "</p>")))
                        (remove cu/empty-value?))]
    (->> paragraphs
         (map (fn [p]
                (let [elements (js->clj (html->pdfmake-elements p))]
                  (if (vector? elements)
                    {:stack elements}
                    {:text  elements
                     :style (:paragraph-style styles)})))))))

(defn excel-report-data
  [db]
  (let [lang-kw (get db ::sub/language)
        survey-config (sub/resolve-config db)
        data (->> survey-config
                  (mapcat
                   (fn [{:keys [block-type] :as block}]
                     (case block-type
                       :survey-block/wysiwyg
                       nil
                       :survey-block/section
                       (->> block
                            :content
                            (map
                             (fn [{:keys [label value data-type options] :as block-cnt}]
                               (println "Q : " block-cnt)
                               (let [text-value (case data-type
                                                  :data.type/ref-single
                                                  (->> options
                                                       (cu/filter-by :value value)
                                                       (first)
                                                       :label)
                                                  :data.type/ref-multi
                                                  (->> options
                                                       (filter (fn [o]
                                                                 (some #{(:value o)}
                                                                       value)))
                                                       (map :label)
                                                       (string/join ", "))
                                                  :data.type/keyword
                                                  (->> options
                                                       (cu/filter-by :value value)
                                                       (first)
                                                       :label)
                                                  :data.type/currency-symbol
                                                  (->> options
                                                       (cu/filter-by :value value)
                                                       (first)
                                                       :label)
                                                  :data.type/date
                                                  (zap-time/long->formatted-date value)
                                                  value
                                                  )]
                                 [label text-value])))
                            (vec))
                       nil)))
                  (vec))]
    data

    ))

(defn generate-pdf-definition
  [db]
  (let [lang-kw (get db ::sub/language)
        survey-config (sub/resolve-config db)
        content (->> survey-config
                     (mapcat
                      (fn [{:keys [block-type] :as block}]
                        (case block-type
                          :survey-block/wysiwyg
                          (let [content (get-in block [:content lang-kw])]
                            (when-not (cu/blank-value? content)
                              (html->pdfmake-content content {:paragraph-style :preface})))
                          :survey-block/section
                          (->> block
                               :content
                               (mapcat
                                (fn [{:keys [label value data-type options]}]
                                  (let [text-value (case data-type
                                                     :data.type/ref-single
                                                     (->> options
                                                          (cu/filter-by :value value)
                                                          (first)
                                                          :label)
                                                     :data.type/ref-multi
                                                     (->> options
                                                          (filter (fn [o]
                                                                    (some #{(:value o)}
                                                                          value)))
                                                          (map :label)
                                                          (string/join ", "))
                                                     :data.type/keyword
                                                     (->> options
                                                          (cu/filter-by :value value)
                                                          (first)
                                                          :label)
                                                     :data.type/currency-symbol
                                                     (->> options
                                                          (cu/filter-by :value value)
                                                          (first)
                                                          :label)
                                                     :data.type/date
                                                     (zap-time/long->formatted-date value)
                                                     value
                                                     )]
                                    [{:text  label
                                      :style :label}
                                     {:text  text-value
                                      :style :value}])))
                               (vec))
                          nil)))
                     (vec))]
    {:content {:stack content}
     :styles  {:main-header  {:fontSize 12
                              :bold     true
                              :margin   [0 0 0 20]}
               :subheader    {:fontSize 15
                              :bold     true}
               :table-header {:fontSize 12
                              :bold     true}
               :quote        {:italics true}
               :preface      {:fontSize  8
                              :alignment "justify"
                              :color     "#666666"
                              :margin    [0 0 0 4]}
               :label        {:fontSize 8
                              :bold     false
                              :margin   [0 4 0 0]
                              :color    "#999999"}
               :link         {:fontSize   11
                              :bold       false
                              :margin     [4 4 4 4]
                              :decoration "underline"
                              :color      "blue"}
               :value        {:fontSize 11
                              :bold     false
                              :margin   [4 4 4 4]
                              :color    "#333333"}
               :file         {:fontSize 11
                              :bold     false
                              :margin   [4 4 4 4]
                              :color    "#333333"}
               :input-line   {:fontSize   11
                              :bold       false
                              :margin     [4 4 4 4]
                              :decoration "underline"
                              :color      "#333333"}}}))

(rf/reg-event-fx
 ::save-as-pdf
 (fn [{db :db} [_]]
   (let [doc-definition (generate-pdf-definition db)
         pdfDoc (.call (aget js/pdfMake "createPdf") js/pdfMake (clj->js doc-definition))]
     (.call (aget pdfDoc "download")
            pdfDoc
            (str "survey.pdf")))))

(rf/reg-event-fx
 ::save-as-excel
 (fn [{db :db} [_]]
   (let [data (excel-report-data db)]
     (excel/export-array-data "survey-data.xlsx"
                              data))))
(rf/reg-event-fx
 ::exit-editor
 (fn [{db :db} [_]]
   {:http-xhrio {:method          :post
                 :uri             "/login/api/logout"
                 :params          {}
                 :timeout         30000
                 :format          (ajax/transit-request-format)
                 :response-format (ajax/transit-response-format)
                 :on-success      [::on-logout-ok]
                 :on-failure      [::on-logout-failed]}}))


(rf/reg-event-fx
 ::save-ok
 (fn [{db :db} [_ survey-id unsaved-answers submit? resp]]
   {:db (-> db
            (update-in [::survey-view-sub/saved-answer-series survey-id]
                       (fn [saved]
                         (if (empty? unsaved-answers)
                           saved
                           (potpuri/deep-merge saved unsaved-answers))))
            (assoc-in [::survey-view-sub/unsaved-answer-series survey-id] {})
            (potpuri/dissoc-in [::survey-view-sub/saving? survey-id]))
    :fx (concat (if submit?
                  [[:dispatch [::survey-view-event/validate-and-submit survey-id]]]
                  [[:dispatch [::survey-view-event/validate survey-id]]
                   [:dispatch [::app-event/load-process survey-id]]]))}))

(rf/reg-event-fx
 ::save-failed
 (fn [{db :db} [_ survey-id err]]
   {:db (potpuri/dissoc-in db [::sub/saving? survey-id])}))

(rf/reg-event-fx
 ::save
 (fn [{db :db} [_ survey-id submit?]]
   (let [unsaved-answers (get-in db [::survey-view-sub/unsaved-answer-series survey-id] {})]
     {:db         (assoc-in db [::survey-view-sub/saving? survey-id] true)
      :http-xhrio {:method          :post
                   :uri             "/surveys/api/save-guest-response-series"
                   :params          {:process-id     survey-id
                                     :series-updates unsaved-answers}
                   :timeout         30000
                   :format          (ajax/transit-request-format)
                   :response-format (ajax/transit-response-format)
                   :on-success      [::save-ok survey-id unsaved-answers submit?]
                   :on-failure      [::save-failed survey-id]}})))

(rf/reg-event-fx
 ::save-and-submit
 (fn [{db :db} [_ survey-id]]
   {:fx [[:dispatch [::save survey-id true]]]}))

